<div fxLayout="column" fxFlex="100" fxLayoutGap="10px" *ngIf="!(data.userExists)">
  <div class="stats-sessions-row">
    <app-stars-lessons-consolidated-count-analtics class="stats-col"
      [dateData$]="api.dateRange$" [selectedApp]="selectedApp"></app-stars-lessons-consolidated-count-analtics>
    <app-stars-lessons-usage-count-analtics class="sessions-col"
      [psData]="data" [dateData$]="api.dateRange$" [selectedApp]="selectedApp"
      formWidth="72%"></app-stars-lessons-usage-count-analtics>
  </div>
  <app-stars-lessons-usage-graph-analtics #starsLessonsUsageGraphAnalticsComponent [selectedApp]="selectedApp"
    [menuSelectedButton]="menuSelectedButton" (emitAnalytics)="changeAnalytics($event)"
    (exportCsvEvent)="exportCsvData($event)" [sessionPlayedChartDatasets]="sessionPlayedChartDatasets"
    [sessionPlayedChartLabels]="sessionPlayedChartLabels"
    [updateChart]="updateChart"></app-stars-lessons-usage-graph-analtics>
</div>

<div fxLayout="column" fxFlex="100" fxLayoutGap="10px" *ngIf="data.userExists">
  <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between stretch">
    <app-stars-user-lesson-session-count-analtics fxFlex="100%" style="display: flex;"
      [userName]="data.username" [dateData$]="api.dateRange$"
      [selectedApp]="selectedApp"></app-stars-user-lesson-session-count-analtics>
  </div>
  <!--
<div fxLayout="row"
     fxLayoutAlign="space-between stretch"
     fxLayoutGap="16px"
     class="analytics-wrapper">

  <app-stars-lesson-session-data-analtics
    fxFlex="35"
    class="full-height"
    [psData]="data"
    [userName]="data.username"
    [dateData$]="api.dateRange$"
    [selectedApp]="selectedApp">
  </app-stars-lesson-session-data-analtics>

  <app-stars-lessons-usage-graph-analtics
    fxFlex="65"
    class="full-height"
    #starsLessonsUsageGraphAnalticsComponent
    [selectedApp]="selectedApp"
    [userName]="data.username"
    [menuSelectedButton]="menuSelectedButton"
    (emitAnalytics)="changeAnalytics($event)"
    (exportCsvEvent)="exportCsvData($event)"
    [sessionPlayedChartDatasets]="sessionPlayedChartDatasets"
    [sessionPlayedChartLabels]="sessionPlayedChartLabels"
    [updateChart]="updateChart">
  </app-stars-lessons-usage-graph-analtics>

</div>
-->
  <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between stretch" fxLayoutGap="16px" class="analytics-container">

    <div fxFlex="35%" fxFlex.lt-md="100%" fxLayout="column">
      <app-stars-lesson-session-data-analtics style="display: flex; flex: 1;" [psData]="data" [userName]="data.username" [dateData$]="api.dateRange$"
        [selectedApp]="selectedApp">
      </app-stars-lesson-session-data-analtics>
    </div>

    <div fxFlex="65%" fxFlex.lt-md="100%" fxLayout="column">
      <app-stars-lessons-usage-graph-analtics style="display: flex; flex: 1;" #starsLessonsUsageGraphAnalticsComponent [selectedApp]="selectedApp"
        [userName]="data.username" [menuSelectedButton]="menuSelectedButton" (emitAnalytics)="changeAnalytics($event)"
        (exportCsvEvent)="exportCsvData($event)" [sessionPlayedChartDatasets]="sessionPlayedChartDatasets"
        [sessionPlayedChartLabels]="sessionPlayedChartLabels" [updateChart]="updateChart">
      </app-stars-lessons-usage-graph-analtics>
    </div>

  </div>

  <!--
<div fxLayout="column" fxLayoutAlign="space-between stretch">
 <app-stars-lesson-session-data-analtics [psData]="data" [userName]="data.username" [dateData$]="api.dateRange$"  [selectedApp]="selectedApp" style="display: contents;"></app-stars-lesson-session-data-analtics>
     <app-stars-lessons-usage-graph-analtics #starsLessonsUsageGraphAnalticsComponent 
    [selectedApp]="selectedApp" [userName]="data.username" [menuSelectedButton]="menuSelectedButton" 
    (emitAnalytics)="changeAnalytics($event)"
    (exportCsvEvent)="exportCsvData($event)"
    [sessionPlayedChartDatasets]="sessionPlayedChartDatasets"
    [sessionPlayedChartLabels]="sessionPlayedChartLabels"
    [updateChart]="updateChart"
  ></app-stars-lessons-usage-graph-analtics>
  </div>-->

</div>